import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  useAddImportBrandMutation,
  useBrandsQuery,
} from "../../services/brandApi";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import CsvImporterBrand from "./csvImportBrand";
import { resetImport, selectfaildData, selectprocessedData } from "../../features/importSlice";
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const ImportBrand = () => {
  const navigate = useNavigate();
  const user = signInUser();
  const { aamarId } = user;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.importReducer);
  const csvData = data?.csvData;
  const processedData = data?.processedData;
  const faildData = data?.faildData;

  const [isProcess, setIsProcess] = useState(false); // Success Data
  const [pp, setPp] = useState(0); // Process Percent

  const [isImportedDone, setIsImportedDone] = useState(false);
  const [AddImportBrand] = useAddImportBrandMutation();

  const { data: brands } = useBrandsQuery({ aamarId });
  console.log("brands", brands);

  // Function to handle input change
  const handleChange = (e, name) => {
    const match = processedData.find((p) => p.name === name);
    const rest = processedData.filter((p) => p.name !== name);
    const updated = {
      ...match,
      name: e,
      isNameUnique: checkBrandName(e) || false,
    };
    dispatch(selectprocessedData([...rest, updated]));
  };

  const handleImport = async () => {
    // console.log("Import", csvData.length, "Products");
    setIsImportedDone(true);

    let newProcessData = processedData;
    let newFailedData = [];
    for (const brand of processedData) {
      //  TODO:: brand name
      const isDuplicate = await checkNameExists(brand.name);
      console.log(isDuplicate, "isDuplicate");

      if (isDuplicate) {
        newFailedData = [
          ...newFailedData,
          {
            name: brand?.name || "",
            aamarId: aamarId,
            company: brand?.company || "",
            status: brand?.status || "active",
          },
        ];
        continue;
      } else {
        if (brand?.name !== null || brand?.isNameUnique !== true) {
          //TODO:: Create each brand
          const result = await AddImportBrand(brand);

          // console.log("result", result);

          if (result?.status !== 500) {
            const matched = newProcessData.find((p) => p.name === brand?.name);
            const rest = newProcessData.filter((p) => p.name !== brand?.name);

            newProcessData = [...rest, { ...matched, isImport: true }];
          } else {
            newFailedData = [
              ...newFailedData,
              {
                name: brand?.name || "",
                aamarId: aamarId,
                company: brand?.company || "",
                status: brand?.status || "active",
              },
            ];
          }
        } else {
          newFailedData = [
            ...newFailedData,
            {
              name: brand?.name || "",
              aamarId: aamarId,
              company: brand?.company || "",
              status: brand?.status || "active",
            },
          ];
        }
      }
    }
    dispatch(selectfaildData(newFailedData));
    dispatch(selectprocessedData(newProcessData));
  };

  // check Name
  const checkNameExists = async (name) => {
    try {
      const response = await fetch(
        ` ${BASE_URL}brand/checkName/${aamarId}/${name}`
      );
      const data = await response.json();
      return data.exists; // Assuming API returns { exists: true } or { exists: false }
    } catch (error) {
      console.error("Error checking Article name:", error);
      return true; // Assume it exists if API fails, to prevent duplicates
    }
  };

  //TODO:: Generate Article_code
  // const generateCode = async () => {
  //   try {
  //     let code;
  //     let isUnique = false;

  //     while (!isUnique) {
  //       code = uuidv4().replace(/\D/g, "").slice(0, 6);

  //       // Ensure the first digit is not 0
  //       if (code.startsWith("0")) {
  //         continue; // Skip and generate a new one
  //       }

  //       isUnique = !(await checkCodeExists(code));
  //     }

  //     return code;
  //   } catch (error) {
  //     console.error("Error generating Article Code:", error);
  //     return null;
  //   }
  // };

  const processCsvData = async (csvData) => {
    dispatch(selectprocessedData([]));
    dispatch(selectfaildData([]));
    let oldData = [];

    // console.log("CSV", csvData);
    let i = 1;
    for (const product of csvData) {
      const newProduct = {
        name: product?.name,
        aamarId: aamarId,
        // photo: "",
        company: product?.company,
        // code: (await generateCode()) || null,
        symbol: product?.symbol,
        status: product?.status || "active",
        order: i++,
        readyToIport: true,
        isImport: false,
        isEditable: checkBrandName(product?.name) || false,
        isNameUnique: checkBrandName(product?.name) || false,
      };
      console.log("PRODUCT", newProduct);

      oldData = [...oldData, newProduct];

      pp >= 0 && setIsProcess(false);

      pp === 100 && setIsProcess(false);
      // await createProduct(newProduct).unwrap();
    }

    dispatch(selectprocessedData(oldData));

    // notify("Product Imported Successfully", "success");
  };

  useEffect(() => {
    console.log("CSV", csvData);
    // console.log("csvData Changes");
    if (csvData?.length > 0) {
      if (csvData?.length !== processedData?.length) {
        csvData?.length > 0 && processCsvData(csvData);
      }
    }
  }, [csvData]);

  useEffect(() => {
    console.log("CSV", csvData);
    // console.log("csvData Changes");
    if (csvData?.length > 0) {
      if (csvData?.length !== processedData?.length) {
        csvData?.length > 0 && processCsvData(csvData);
      }
    }
  }, []);

  useEffect(() => {
    setIsProcess(true);
    setPp(0);
    // let progress = 0;
    const processPercent = (100 / csvData?.length) * processedData?.length;

    // console.log("Process Percent");
    setPp(processPercent || 0);
    // setIsProcess(true);
    // csvData.length > 0 && processCsvData(csvData);
  }, [processedData]);

  console.log("processedData", processedData);
  //   const getbrandIdbyName = (name) => {
  //     if (brands) {
  //       const result = brands?.find(
  //         (grp) => grp?.name?.toLowerCase() === name?.toLowerCase()
  //       );
  //       // console.log(result);
  //       return result?._id;
  //     } else {
  //       return null;
  //     }
  //   };

  //   const checkBrandName = (name) => {
  //     if (brands) {
  //       const result = brands?.find(
  //         (brand) => brand?.name?.toLowerCase() === name?.toLowerCase()
  //       );
  //       console.log("brand",brands, name, result);
  //       return result?.name;
  //     } else {
  //       return null;
  //     }
  //   };

  const checkBrandName = (name) => {
    return (
      !brands?.some(
        (brand) => brand?.name?.toLowerCase() === name?.toLowerCase()
      ) || false
    );
  };

  // // check code
  // const checkCodeExists = async (code) => {
  //   return (
  //     brands?.some(
  //       (brand) => brand?.code?.toLowerCase() === code?.toLowerCase()
  //     ) || false
  //   );
  // };

  //   console.log("PP", pp);
  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-2">
            <SideBar />
          </div>
          <div className="col-md-10">
            <Header title="Import brand" />
            <div className="row">
              <div className="col-md-12 table-responsive">
                {csvData?.length <= 0 ? (
                  <div
                    className="d-flex justify-content-center align-items-center vh-100 "
                    style={{ marginTop: "-80px" }}
                  >
                    <div className="col-6">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <p className="p-0 m-0 fw-bold">Import brands</p>
                          <p className="p-0 m-0">
                            <small>
                              Please check the format before uploading
                              <a
                                href="/importSample/importBrandsSample.csv"
                                download
                                className="text-primary text-opacity-75 text-decoration-none d-inline-flex align-items-center gap-1"
                                style={{ transition: "color 0.3s ease-in-out" }}
                              >
                                <Icons.Download size="15" />
                                Download
                              </a>{" "}
                              the sample file
                              {/* File to check the format before uploading. */}
                            </small>
                          </p>
                        </div>
                      </div>
                      <div>
                        <CsvImporterBrand />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-12">
                      <p className="d-flex justify-content-between p-2">
                        Total Product: {csvData?.length}{" "}
                        <span className="input-brand-text">
                          <span
                            className="input-brand-text gap-2"
                            id="basic-addon1"
                          >
                            {isImportedDone && faildData?.length > 0 && (
                              // TODO:: MAKE THIS BUTTON EXPOrt FAILD

                              <CSVLink
                                data={faildData}
                                filename="failed_products.csv"
                                className="btn btn-dark"
                              >
                                <Icons.Download size="18" /> Export Failed Data
                              </CSVLink>
                            )}
                            {!isImportedDone && (
                              <button
                                onClick={() => handleImport()}
                                className="btn btn-dark btn-block"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.Upload size="18" /> Import Brand
                              </button>
                            )}
                            {!isImportedDone && (
                              <button
                                onClick={() => {
                                  processCsvData(csvData);
                                  setIsImportedDone(false);
                                }}
                                className="btn btn-outline-dark btn-block"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.Refresh size="18" /> Reload
                              </button>
                            )}

                            <button
                              onClick={() => {
                                dispatch(resetImport());
                                setIsImportedDone(false);
                              }}
                              className="btn btn-outline-dark btn-block"
                              style={{ zIndex: 0 }}
                            >
                              {!isImportedDone ? "Cancle" : "Import Again"}{" "}
                              <Icons.X size="18" />
                            </button>
                            {isImportedDone && (
                              <button
                                onClick={() => {
                                  dispatch(resetImport());
                                  setIsImportedDone(false);
                                  navigate("/brand");
                                }}
                                className="btn btn-outline-success btn-block"
                                style={{ zIndex: 0 }}
                              >
                                <Icons.CheckCircle size="18" /> Done
                              </button>
                            )}
                          </span>
                        </span>
                      </p>
                    </div>
                    {!isProcess ? (
                      <div className="col-md-6 offset-md-3 col-12 ">
                        <div
                          className="d-flex justify-content-center align-items-left flex-column w-100"
                          style={{ height: "60vh" }}
                        >
                          <h3>Processing Data {pp}%</h3>
                          <div className="w-100">
                            <ProgressBar
                              animated
                              striped
                              variant="success"
                              now={pp}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="col-12">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Brand Name</th>
                              <th>Company</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {processedData.length > 0 ? (
                              processedData
                                ?.slice()
                                ?.sort((a, b) => a.order - b.order)
                                ?.map((item, index) => (
                                  <tr key={index}>
                                    <th>{index + 1}</th>
                                    <td>
                                      {item?.isEditable ? (
                                        //     <input
                                        //     className="form-control"
                                        //     value={item?.name}
                                        //     onChange={(e) => handleChange(e.target.value,item?.code)} // If needed for editing
                                        //     style={{
                                        //     //   border: "1px solid",
                                        //       outline: "none",
                                        //       width: "200px", // Adjust the width as needed
                                        //       padding: "5px", // To ensure text fits comfortably
                                        //     }}
                                        //   />
                                        item?.name
                                      ) : (
                                        <input
                                          className="form-control"
                                          value={item?.name}
                                          onChange={(e) =>
                                            handleChange(
                                              e.target.value,
                                              item?.name
                                            )
                                          } // If needed for editing
                                          style={{
                                            border: `1px solid ${
                                              item?.isNameUnique ? "" : "tomato"
                                            }`,
                                            outline: "none",
                                            width: "200px", // Adjust the width as needed
                                            padding: "5px", // To ensure text fits comfortably
                                          }}
                                        />
                                      )}
                                    </td>

                                    <td>{item?.company}</td>
                                    {/* <td>{item?.status}</td> */}

                                    <td
                                      className={
                                        item?.isEditable
                                          ? item?.isNameUnique
                                            ? "text-success"
                                            : item?.isImport
                                            ? item?.isNameUnique
                                              ? "text-danger"
                                              : "text-success"
                                            : "text-success"
                                          : item?.isNameUnique
                                          ? "text-success"
                                          : "text-danger"
                                      }
                                    >
                                      {/* 
                                      {item?.isEditable
                                        ? item?.isNameUnique
                                          ? "Ready"
                                          : item?.isImport
                                          ? item?.isNameUnique
                                            ? "Failed"
                                            : "Ready"
                                          : "Ready"
                                        : "Failed"} */}

                                      {item?.isEditable
                                        ? item?.isNameUnique
                                          ? "Ready"
                                          : item?.isImport
                                          ? item?.isNameUnique
                                            ? "Failed"
                                            : "Ready"
                                          : "Ready"
                                        : item?.isNameUnique
                                        ? item?.isImport
                                          ? "Done"
                                          : "Ready"
                                        : "Failed"}
                                    </td>
                                  </tr>
                                ))
                            ) : (
                              <tr>
                                <td colSpan="15" className="text-center">
                                  No Data Available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <Toaster position="bottom-right" />
        </div>
      </div>
    </div>
  );
};

export default ImportBrand;
